import api from "../config/api";

/**
 * O "Feedback ao estudante" de um Debriefing: retorno estruturado que o
 * avaliador revisa e publica. Enquanto `status === "draft"` só o avaliador o
 * vê; o aluno recebe 404 até a publicação (a regra mora no backend).
 */
export interface StudentFeedback {
  id: number;
  debriefing_id: number;
  appraiser_id: number | null;
  appraiser_name?: string | null;
  status: "draft" | "published";
  published_at: string | null;
  overview: string | null;
  strengths: string[] | null;
  improvements: string[] | null;
  recommendations: string[] | null;
  final_guidance: string | null;
  updated_at?: string;
}

export interface StudentFeedbackPayload {
  overview: string;
  strengths: string[];
  improvements: string[];
  recommendations: string[];
  final_guidance: string;
}

const getStudentFeedback = (debriefingId: string | number) => {
  return api.get<StudentFeedback>(
    `/feedbacks/debriefings/${debriefingId}/student-feedback`
  );
};

const saveStudentFeedback = (
  debriefingId: string | number,
  data: StudentFeedbackPayload
) => {
  return api.put<StudentFeedback>(
    `/feedbacks/debriefings/${debriefingId}/student-feedback`,
    data
  );
};

const publishStudentFeedback = (debriefingId: string | number) => {
  return api.post<StudentFeedback>(
    `/feedbacks/debriefings/${debriefingId}/student-feedback/publish`
  );
};

const StudentFeedbackService = {
  getStudentFeedback,
  saveStudentFeedback,
  publishStudentFeedback,
};

export default StudentFeedbackService;
